// src/pages/SellerIntelligence/GeographicSales/GeographicSales.js
//
// Geographic Sales Intelligence. Sellers see one national number; this breaks
// it down by where the orders actually went.
//
// The table is the primary surface and there is no map in v1, deliberately —
// a map shows you which states are large, which you already know, while a
// ranked table shows you which are large relative to everything else.
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';

import styles from '../SellerIntelligence.module.css';
import { WindowControl, useWindowControl } from '../components/WindowControl';
import ProductIndex from './components/ProductIndex';
import TrueDemand from './components/TrueDemand';
import RegionTable from './components/RegionTable';

// SF1–SF4 and SF6 are all built. SF5 is parked in the PRD itself — Amazon India
// permits one national price per ASIN, so a seller cannot act on geographic cost
// variance through pricing, and the only real response is inventory placement.

const GeographicSales = () => {
  const navigate = useNavigate();
  const control = useWindowControl();

  return (
    <div className={styles.featureContainer}>
      <div className={styles.header}>
        <button
          className={styles.backButton}
          onClick={() => navigate('/dashboard/seller-intelligence/sales')}
        >
          <FiArrowLeft /> Back
        </button>
        <div className={styles.titleSection}>
          <div className={styles.iconTitle}><h1>Geographic Sales Intelligence</h1></div>
          <p>
            Which states, cities and pincodes drive your revenue, and which
            products sell differently by region.
          </p>
        </div>
      </div>

      <div className={styles.content}>
        <WindowControl control={control} />


        <RegionTable window={control.applied} onLoadingChange={control.track('regionTable')} />
        <ProductIndex window={control.applied} onLoadingChange={control.track('productIndex')} />
        <TrueDemand window={control.applied} onLoadingChange={control.track('trueDemand')} />
      </div>
    </div>
  );
};

export default GeographicSales;
